import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="report-loader"
export default class extends Controller {
  static targets = [
    "overlay", "progressBar", "statusText", "percentText", 
    "previewForm", "exportForm", "downloadLinkContainer", "downloadUrl"
  ]

  connect() {
    this.isProcessing = false
  }

  submitPreview(event) {
    event.preventDefault()
    if (this.isProcessing) return

    const form = event.currentTarget.closest("form")
    this.showLoader("Generating Report Preview...", () => {
      form.submit()
    })
  }

  submitExport(event) {
    event.preventDefault()
    if (this.isProcessing) return

    const form = event.currentTarget.closest("form")
    this.showLoader("Generating Excel Workbook...", () => {
      // Create a temporary link or submit the form for download
      form.submit()
      
      // Show the download link in the stats card
      if (this.hasDownloadLinkContainerTarget) {
        this.downloadLinkContainerTarget.classList.remove("hidden")
        
        // Generate a pseudo-url or message for re-downloading
        // Since it's a form submit, we can just allow them to click again
        const now = new Date()
        const timeStr = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })
        if (this.hasDownloadUrlTarget) {
          this.downloadUrlTarget.innerHTML = `Stock_Report_${now.getFullYear()}${(now.getMonth()+1).toString().padStart(2,'0')}${now.getDate().toString().padStart(2,'0')}.xlsx (Generated at ${timeStr})`
        }
      }
    })
  }

  showLoader(initialText, onComplete) {
    this.isProcessing = true
    
    // Show overlay
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("hidden")
      this.overlayTarget.classList.add("flex")
    }

    let progress = 0
    const interval = setInterval(() => {
      progress += Math.floor(Math.random() * 15) + 5
      if (progress >= 100) {
        progress = 100
        clearInterval(interval)
        
        if (this.hasProgressBarTarget) this.progressBarTarget.style.width = "100%"
        if (this.hasPercentTextTarget) this.percentTextTarget.textContent = "100%"
        if (this.hasStatusTextTarget) this.statusTextTarget.textContent = "Finished!"

        setTimeout(() => {
          // Hide overlay
          if (this.hasOverlayTarget) {
            this.overlayTarget.classList.add("hidden")
            this.overlayTarget.classList.remove("flex")
          }
          this.isProcessing = false
          
          // Execute callback
          if (onComplete) onComplete()
        }, 300)
      } else {
        if (this.hasProgressBarTarget) this.progressBarTarget.style.width = `${progress}%`
        if (this.hasPercentTextTarget) this.percentTextTarget.textContent = `${progress}%`
        
        // Update status text based on progress stage
        if (this.hasStatusTextTarget) {
          if (progress < 30) {
            this.statusTextTarget.textContent = "Connecting to queue worker..."
          } else if (progress < 60) {
            this.statusTextTarget.textContent = "Processing stock transactions..."
          } else if (progress < 85) {
            this.statusTextTarget.textContent = initialText
          } else {
            this.statusTextTarget.textContent = "Finalizing output stream..."
          }
        }
      }
    }, 100)
  }

  // Trigger download when re-clicking the link
  reDownload(event) {
    event.preventDefault()
    // Submit the export form again
    const exportForm = this.element.querySelector("form[action*='reports']")
    if (exportForm) {
      exportForm.submit()
    }
  }
}
